/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

export default function addTabIndex (e) {
  const list = e.target.querySelectorAll('li.filepond--item')

  list.forEach(item => {
    item.setAttribute('tabindex', '0')
    item.setAttribute('aria-describedby', 'ih-reorder-description')
  })
}
